import React from 'react';
import HeaderComponent from './header.component';

function Header(props) {
    return <HeaderComponent {...props} />;
}

export default Header;
